define('Components/Comein/js/views/pages/AuthentificationComeinPageView',['underscore', 'backbone', 'jquery', 'app',
    'views/pages/AuthentificationPageView',
    'Components/Comein/js/views/blocks/AuthentificationView',
    'template!Components/Comein/templates/authentification',
    'template!Components/Comein/templates/blocks/account/authentification',
], function (_, Backbone, $, app,
             AuthentificationPageView,
             AuthentificationView,
             authentificationTemplate,
             blocksAuthentificationTemplate
)
{
    var view;

    function RenderHeader($canvas){
        var canvas = $canvas.get(0);
        if(!canvas) return;
        var DPR = window.devicePixelRatio,
            W = $canvas.width()*DPR,
            H = $canvas.height()*DPR,
            ICON_SIZE = 25*DPR,
            V_SPACE = 3,
            H_SPACE = 1.5,
            ctx = canvas.getContext('2d');
        //
        ctx.canvas.width = W;
        ctx.canvas.height = H;
        ctx.font         = ICON_SIZE+'px icomoon';
        ctx.textBaseline = 'top';
        var x = 0, y = -ICON_SIZE*V_SPACE/3, n = 0, l, opacity = 0.35, fillstyle,
            icons = [
                "\ue003", // comein
                "\ue601", // ni
                "\ue132", // cook
                "\ue335", // vod
                "\ue133", // products-pack
                "\ue600", // ichi
                "\ue111", // prepare
                "\ue115", // flatware
                "\ue602" // san
            ];
        //
        while(y<=H+ICON_SIZE){
            n++;
            x = n%2 === 0 ? -ICON_SIZE*V_SPACE : -ICON_SIZE*V_SPACE/2;
            l = (n*2+n) % icons.length;
            opacity = opacity - 0.07;
            opacity = parseFloat(opacity.toFixed(2));
            fillstyle = 'rgba(255,255,255,' + opacity +')';
            while (x<=W+ICON_SIZE){
                ctx.setTransform(1, 0, 0, 1, 0, 0); // polyfill of resetTransform
                ctx.translate(x,y);
                ctx.rotate(-45* Math.PI / 180);
                ctx.fillStyle = fillstyle;
                ctx.fillText(icons[l%icons.length], 0, 0);
                ctx.fill();
                x+=ICON_SIZE*V_SPACE;
                l++;
            }
            y+=ICON_SIZE*H_SPACE;
        }
    }

    var AuthentificationComeinPageView = AuthentificationPageView.extend({

        className: 'page Authentification authentification-comein',

        initialize: function ()
        {
            view = this;
            AuthentificationPageView.prototype.initialize.apply(view, arguments);
            view.listenTo(app,'resize',view.resize);
        },

        render: function ()
        {
            var datas = view.$('.authentification-comein').data(),
                customer = app.getCustomer(),
                // on surcharge les données qui viennent du DOM
                // avec des valeurs par défaut
                templateOptions = _.defaults(datas || {},{
                    id:view.cid,
                    login_url: '',
                    theme:'dark',
                    phone:customer.getPhone() || '',
                    email:customer.getEmail() || '',
                    id_comein:''
                });

            // on rend les templates et on l'ajoute au DOM
            view.$el.html(authentificationTemplate());
            view.$('.authentification-block').html( blocksAuthentificationTemplate(templateOptions) );

            // on instancie la sous-vue d'authentification
            var authentificationView = new AuthentificationView(_.defaults({
                el: view.$('.authentification-block').get(0)
            },templateOptions));

            view.attachView(authentificationView);

            authentificationView.render();

            RenderHeader(view.$('canvas'));

        },

        successLogin:function(){
            console.log('do nothing successLogin')
        },

        resize:function(){
            RenderHeader(view.$('canvas'));
        }

    });

    return AuthentificationComeinPageView;

});
